export default __webpack_public_path__ + "static/media/blog8.630ea3f8.jpg";